import React from 'react';
import { Tabs } from 'tdesign-react';
import TabPanel from 'tdesign-react/es/tabs/TabPanel';
import Markdown from '@/pages/Dev/components/Markdown';
import { doBuried } from '@/services/buriedService';

export default function Code({ brokerServiceUrl }) {
  const content1 = `
  1.下载包到本地
  ~~~bash~DEV_GOLANG_DEP_1_COPY
    go get -u "github.com/apache/pulsar-client-go/pulsar"
  ~~~
  2.导入你的项目中
  ~~~bash~DEV_GOLANG_DEP_2_COPY
    import "github.com/apache/pulsar-client-go/pulsar"
  ~~~
  `;
  const content2 = `
  ~~~go~DEV_GOLANG_PRODUCER_COPY
  package main
  import (
    "context"
    "fmt"
    "log"
  
    "github.com/apache/pulsar-client-go/pulsar"
  )
  
  func main() {
      log.Println("Pulsar Producer")
  
      // 参数配置
      // YOUR_PULSAR_TOKEN需要在角色菜单中自行配置
      tokenStr := YOUR_PULSAR_TOKEN
      uri := "${brokerServiceUrl}"
      topicName := "persistent://public/default/test"
  
    token := pulsar.NewAuthenticationToken(tokenStr)
  
    client, err := pulsar.NewClient(pulsar.ClientOptions{
      URL:                     uri,
      Authentication:          token,
    })
  
    if err != nil {
      log.Fatalf("Could not instantiate Pulsar client: %v", err)
    }
  
    defer client.Close()
  
    log.Printf("creating producer...")
  
    producer, err := client.CreateProducer(pulsar.ProducerOptions{
      Topic: topicName,
    })
  
    log.Printf("checking error of producer creation...")
    if err != nil {
      log.Fatal(err)
    }
  
    defer producer.Close()
  
    ctx := context.Background()
  
    // 发送3条异步消息
    for i := 0; i < 3; i++ {
  
      asyncMsg := pulsar.ProducerMessage{
        Payload: []byte(fmt.Sprintf("asyncMessageId-%d", i)),
      }
  
      producer.SendAsync(ctx, &asyncMsg, func(msgID pulsar.MessageID, msg *pulsar.ProducerMessage, err error) {
        if err != nil {
          log.Fatal(err)
        }
  
        log.Printf("the %s successfully published with the message ID %v", string(msg.Payload), msgID)
      })
    }
  }
  ~~~
  `;
  const content3 = `
  ~~~go~DEV_GOLANG_CONSUMER_COPY
  package main
  import (
    "context"
    "log"
  
    "github.com/apache/pulsar-client-go/pulsar"
  )
  
  func main() {
      log.Println("Pulsar Consumer")

      // YOUR_PULSAR_TOKEN需要在角色菜单中自行配置
      tokenStr := YOUR_PULSAR_TOKEN
      uri := "${brokerServiceUrl}"
      topicName := "persistent://public/default/test"
      subscriptionName := "sub_test"
  
    token := pulsar.NewAuthenticationToken(tokenStr)
  
    client, err := pulsar.NewClient(pulsar.ClientOptions{
      URL:                   uri,
      Authentication:        token,
    })
  
    if err != nil {
      log.Fatal(err)
    }
  
    defer client.Close()
  
    consumer, err := client.Subscribe(pulsar.ConsumerOptions{
      Topic:            topicName,
      SubscriptionName: subscriptionName,
      SubscriptionInitialPosition: pulsar.SubscriptionPositionEarliest,
    })
  
    if err != nil {
      log.Fatal(err)
    }
  
    defer consumer.Close()
  
    ctx := context.Background()
  
    for {
      msg, err := consumer.Receive(ctx)
      if err != nil {
        log.Fatal(err)
      } else {
        log.Printf("Received message : %s", string(msg.Payload()))
      }
  
      consumer.Ack(msg)
    }
  
  }
  ~~~
  `;
  return (
    <Tabs defaultValue='DEV_GOLANG_DEP' onChange={(val) => doBuried({ eventId: val })}>
      <TabPanel value='DEV_GOLANG_DEP' label='Dep'>
        <Markdown content={content1} />
      </TabPanel>
      <TabPanel value='DEV_GOLANG_PRODUCER' label='Producer'>
        <Markdown content={content2} />
      </TabPanel>
      <TabPanel value='DEV_GOLANG_CONSUMER' label='Consumer'>
        <Markdown content={content3} />
      </TabPanel>
    </Tabs>
  );
}
